import { Button, Modal, Space } from 'antd';
import { isEmpty, get } from 'lodash';
import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import moment from 'moment';
import MyUtil from '../../functions/MyUtil';

class ShowHashButton extends React.Component {
  constructor(props) {
    super(props);
    const booking = this.props.record;
    const { paymentStatus } = booking.payment_info.paymentDetail;
    const paymentMethod = get(
      booking,
      ['payment_info', 'paymentMethodInfo', 'paymentMethod'],
      0
    );
    const valueUploadDocument = `https://chungxe.vn/booking/${booking.book_code}?hash=${booking.bookingHash}`;
    const valueUploadInsurance = `https://chungxe.vn/booking/${booking.book_code}/insurance/create?hash=${booking.bookingHash}`;
    const valueViewInfoForPartner = `https://backend.chungxe.vn/widget/partner/booking/${booking.book_code}?hash=${booking.bookingHash}`;
    const quickPayLink = `https://chungxe.vn/chuyen/${booking.book_code}/thanh-toan`;
    const orderInfo = `https://chungxe.vn/hoan-thanh/${booking.book_code}`;

    this.state = {
      quickPayLink,
      valueUploadDocument,
      valueUploadInsurance,
      valueViewInfoForPartner,
      paymentStatus,
      paymentMethod,
      orderInfo,
      visible: false,
    };

    this.showModal = this.showModal.bind(this);
  }

  async showModal() {
    const booking = this.props.record;
    const partner = await PartnerApi.getDetailPartner(
      booking.part_id_actual || booking.part_id
    );

    this.setState({
      visible: true,
      partner: partner,
    });
  }

  handleCancel = (e) => {
    this.setState({
      visible: false,
      partner: {},
    });
  };

  copyInformationBooking = () => {
    const partner = this.state.partner;
    const dataMessage = this.getMessageArray(partner);

    const text =
      'ĐƠN XÁC NHẬN ĐẶT XE:\n\n' +
      dataMessage
        .map((value) => {
          return `${value.title}: ${value.content}`;
        })
        .join('\n') +
      '\n\n';

    const part2 = [
      'Thủ tục',
      'Giấy tờ thế chấp (bản gốc giữ lại):',
      'Tài sản thế chấp (giữ lại):',
      'GPLX, CMND (xác minh, không giữ lại):',
      '',
      `Liên hệ nhận xe: ${partner.part_ctac_name} - ${partner.part_ctac_mobi}`,
      `Địa chỉ: ${partner.part_addr ?? ''}`,
    ].join('\n');

    return text + part2;
  };

  getBookingPriceTotal(booking) {
    if (booking.book_price_total_actual > 0) {
      return booking.book_price_total_actual;
    }
    return booking.book_prie_tota;
  }

  getMessageArray = (partner) => {
    const booking = this.props.record;
    const bookingPriceTotal = this.getBookingPriceTotal(booking);
    const paidAmount =
      (booking.paid_amount || 0) - (booking.paid_amount_insurance || 0);
    const extraFee = booking.extra_fee || 0;
    const dueAmount = (bookingPriceTotal || 0) - (paidAmount || 0) + extraFee;

    return [
      {
        title: 'Mã Booking',
        content: booking.book_code ?? '',
      },
      {
        title: 'Khách hàng',
        content: booking.cstm_name ?? '',
      },
      {
        title: 'Số điện thoại',
        content: booking.cstm_phon ?? '',
      },
      {
        title: 'Địa chỉ nhận xe',
        content: booking.cstm_deli_addr ?? '',
      },
      {
        title: 'Giờ nhận xe',
        content: moment(booking.book_rental_date_actual).format('HH:mm'),
      },
      {
        title: 'Ngày nhận xe',
        content: moment(booking.book_rental_date_actual).format('DD/MM/YYYY'),
      },
      {
        title: 'Giờ trả xe',
        content: moment(booking.book_return_date_actual).format('HH:mm'),
      },
      {
        title: 'Ngày trả xe',
        content: moment(booking.book_return_date_actual).format('DD/MM/YYYY'),
      },
      {
        title: 'Tên xe',
        content: booking.vhc_part_name_actual ?? booking.vhc_part_name,
      },
      {
        title: 'Số ngày thuê',
        content: `${booking.book_day_num_actual ?? 0} ngày`,
      },
      {
        title: 'Tổng giá',
        content: `${
          bookingPriceTotal ? MyUtil.currencyFormat(bookingPriceTotal) : 0
        } VND`,
      },
      {
        title: 'Phí bảo hiểm đã thanh toán',
        content: `${
          booking.paid_amount_insurance
            ? MyUtil.currencyFormat(booking.paid_amount_insurance)
            : 0
        } VND`,
      },
      {
        title: 'Phí giao nhận/rửa xe (nếu có)',
        content: `${extraFee ? MyUtil.currencyFormat(extraFee) : 0} VND`,
      },
      {
        title: 'Cọc Chungxe',
        content: `${MyUtil.currencyFormat(paidAmount)} VND`,
      },
      {
        title: 'Thanh toán khi nhận xe',
        content: `${dueAmount ? MyUtil.currencyFormat(dueAmount) : 0} VND`,
      },
      {
        title: 'Giới hạn Km',
        content: `${partner.part_lim_km ?? ''} km/ngày`,
      },
      {
        title: 'Quá Km',
        content: `${
          partner.part_over_km_fee
            ? MyUtil.currencyFormat(partner.part_over_km_fee)
            : 0
        } VND/km`,
      },
      {
        title: 'Lịch trình đi',
        content: booking.book_schl ?? '',
      },
    ];
  };

  render() {
    const {
      valueUploadDocument,
      quickPayLink,
      paymentStatus,
      paymentMethod,
      visible,
      valueUploadInsurance,
      valueViewInfoForPartner,
      orderInfo,
    } = this.state;

    let isShowQuickPay = true;

    if (paymentStatus === 'success' && 2 === paymentMethod) {
      isShowQuickPay = false;
    }

    const booking = this.props.record;
    return (
      <>
        {visible && (
          <Modal
            title="Link nhanh"
            visible
            onCancel={this.handleCancel}
            footer={null}
          >
            <div className="d-flex justify-content-between">
              Upload hồ sơ
              <Space>
                <Button href={valueUploadDocument} target="blank">
                  Mở
                </Button>
                <CopyToClipboard text={valueUploadDocument}>
                  <Button type="primary">Copy</Button>
                </CopyToClipboard>
              </Space>
            </div>
            {!isEmpty(booking.bookingAddons) && (
              <div className="d-flex justify-content-between mt-2">
                Upload bảo hiểm
                <Space>
                  <Button href={valueUploadInsurance} target="blank">
                    Mở
                  </Button>
                  <CopyToClipboard text={valueUploadInsurance}>
                    <Button type="primary">Copy</Button>
                  </CopyToClipboard>
                </Space>
              </div>
            )}
            <div className="d-flex justify-content-between mt-2">
              Xem thông tin cho đối tác
              <Space>
                <Button href={valueViewInfoForPartner} target="blank">
                  Mở
                </Button>
                <CopyToClipboard text={valueViewInfoForPartner}>
                  <Button type="primary">Copy</Button>
                </CopyToClipboard>
              </Space>
            </div>
            <div className="d-flex justify-content-between mt-2">
              Thông tin đơn đặt xe
              <Space>
                <Button href={orderInfo} target="blank">
                  Mở
                </Button>
                <CopyToClipboard text={this.copyInformationBooking()}>
                  <Button type="primary">Copy</Button>
                </CopyToClipboard>
              </Space>
            </div>
            {isShowQuickPay ? (
              <div className="d-flex justify-content-between mt-2">
                Link thanh toán nhanh
                <Space>
                  <Button href={quickPayLink} target="blank">
                    Mở
                  </Button>
                  <CopyToClipboard text={quickPayLink}>
                    <Button type="primary">Copy</Button>
                  </CopyToClipboard>
                </Space>
              </div>
            ) : (
              <div className="d-flex justify-content-between mt-2">
                Link thanh toán nhanh
                <Space>Đã thanh toán thành công</Space>
              </div>
            )}
            <br />
          </Modal>
        )}
        <Button
          onClick={this.showModal}
          size="small"
          className="pull-right"
          title="Link upload hồ sơ"
        >
          <i className="fas fa-copy"></i>
        </Button>
      </>
    );
  }
}
export default ShowHashButton;
